import React from 'react';

export const Contract = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 44 46">
      <path
        stroke="#FFAF70"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.896"
        d="M37.021 39.205l-7.449 1.49m.813-8.414l-3.514 1.443a2.275 2.275 0 01-1.862-4.148l3.513-1.706a3.142 3.142 0 012.48-.143l6.413 2.454"
      ></path>
      <path
        stroke="#FFAF70"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.896"
        d="M16.166 40.813h2.655l4.417 3.357c.463.519 1.252.58 1.79.14l6.635-5.321a1.297 1.297 0 00.2-1.8l-3.645-4.015m-3.501-3.404l-.474-.391a2.79 2.79 0 00-2.683-.341l-5.393 2.295"
      ></path>
      <path
        stroke="#FFAF70"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.896"
        d="M10.479 42.708h3.792a1.896 1.896 0 001.895-1.895v-9.48a1.896 1.896 0 00-1.895-1.895h-3.792v13.27zm32.23 0h-3.792a1.896 1.896 0 01-1.896-1.895v-9.48c0-1.047.849-1.895 1.896-1.895h3.791v13.27z"
        clipRule="evenodd"
      ></path>
      <path
        stroke="#FFAF70"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.896"
        d="M30.385 1H6.687A5.687 5.687 0 001 6.688v36.968c0 .524.424.948.948.948h4.74m0-36.021h13.27M6.688 14.27h13.27m-13.27 5.688h6.635"
      ></path>
      <path
        stroke="#FFAF70"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.896"
        d="M25.646 24.698V5.74A4.74 4.74 0 0130.386 1c2.616 0 4.74 2.121 4.74 5.688h-9.48"
      ></path>
    </svg>
  );
};
